import React, { useCallback, FC, useState, useEffect } from 'react';

import { Grid, Paper } from '@material-ui/core';

import { ScoreType } from '../../../../../../store/admin/eventFormats/store';

import {
  StyledContestSelectorItem,
  CheckCircleRoundedIconStyled,
  RadioButtonUncheckedRoundedIconStyled
} from './ContestSelectorItem.Styles';
import { useContestSetupDispatch, useContestSetupState } from '../../Context/ContestSetup.context';
import { IContestSelectorOption } from '../../Context/BoundActionCreators/setContestSelectorOptions';

interface IProps {
  contestSelectorOption: IContestSelectorOption;
}

const ContestSelectorItem: FC<IProps> = props => {
  const {
    contestSelectorOption: {
      value: {
        metaFormat,
        metaFormat: { format, considerFlights },
        scoreType
      }
    }
  } = props;

  const { selectedMetaFormat, selectedScoreType, leaderboards } = useContestSetupState();

  const {
    actions: { selectFormat }
  } = useContestSetupDispatch();

  const selectContest = useCallback(() => {
    selectFormat(scoreType, metaFormat);
  }, [selectFormat, scoreType, metaFormat, leaderboards]);

  const [contestHasSelectedEnrollments, setContestHasSelectedEnrollments] = useState(false);
  const [contestIsSelected, setContestIsSelected] = useState(false);

  useEffect(() => {
    const currentLeaderboard = Object.values(leaderboards).find(
      leaderboard => leaderboard.format === metaFormat.id && leaderboard.scoreType === scoreType
    );

    if (currentLeaderboard) {
      setContestHasSelectedEnrollments(currentLeaderboard.enrollments.length > 0);
    }
  }, [selectedMetaFormat, metaFormat, scoreType, selectedScoreType, leaderboards]);

  useEffect(() => {
    setContestIsSelected(
      !!selectedMetaFormat &&
        selectedMetaFormat.id === metaFormat.id &&
        selectedScoreType === scoreType
    );
  }, [selectedMetaFormat, metaFormat, scoreType, selectedScoreType]);

  return (
    <StyledContestSelectorItem>
      <Paper
        className={`paper ${contestIsSelected ? 'selected-contest' : ''}`}
        elevation={1}
        onClick={selectContest}
      >
        <Grid className="grid-container" container={true} alignItems={'center'}>
          <Grid className="grid-item left" item={true} xs={9}>
            <p className="contestName">{format.name}</p>

            <p className="contestType">{considerFlights ? 'Contest by flight' : 'All flights'}</p>
          </Grid>

          <Grid className="grid-item right" item={true} xs={2}>
            {format.prefix !== 'ctp' && <p className="formatType">{ScoreType[scoreType]}</p>}
          </Grid>

          <Grid className="grid-item right" item={true} xs={1}>
            {contestHasSelectedEnrollments ? (
              <CheckCircleRoundedIconStyled />
            ) : (
              <RadioButtonUncheckedRoundedIconStyled />
            )}
          </Grid>
        </Grid>
      </Paper>
    </StyledContestSelectorItem>
  );
};

export default ContestSelectorItem;
